import { useMsal } from "@azure/msal-react";
import { loginRequest } from "authConfig";
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React imports
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Updated background image
import bgImage from "assets/images/homepage.png"; // Ensure this image is placed correctly in your project
import projectLogo from "assets/images/whodat-Logo.png";

function Basic() {
  const { instance: msalInstance } = useMsal(); // Access msalInstance from the MSAL hook
  const navigate = useNavigate(); // React Router's navigation function

  const handleLogin = () => {
    msalInstance
      .loginPopup(loginRequest) // Perform popup login
      .then((response) => {
        console.log("Login successful!", response);

        // Redirect to the desired route after login
        navigate("/leakEventForm");
      })
      .catch((error) => {
        console.error("Login failed:", error);
      });
  };

  return (
    <BasicLayout image={bgImage}>
      {/* Main container */}
      <MDBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        {/* Logo Container */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "130%",
            maxWidth: "800px",
            padding: "1rem",
            marginTop: "-5rem",
            marginBottom: "1rem",
            background: "rgb(255, 255, 255)",
            borderRadius: "12px",
          }}
        >
          <img src={projectLogo} alt="Project Logo" style={{ width: "100%", height: "auto" }} />
        </MDBox>

        {/* Login Card */}
        <Card
          sx={{
            marginTop: "5rem",
            background: "rgba(0, 0, 0, 0.2)",
            color: "white",
            borderRadius: "16px",
            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.36)",
            padding: "2rem",
            maxWidth: "400px",
            textAlign: "center",
            backdropFilter: "blur(8px)",
          }}
        >
          <MDBox mb={3}>
            <MDTypography variant="h4" fontWeight="bold" color="white">
              Learning Management System
            </MDTypography>
          </MDBox>
          <MDBox>
            <MDButton
              variant="contained"
              onClick={handleLogin}
              sx={{
                background: "(90deg,rgb(21, 30, 195),rgba(43, 108, 193, 0))",
                color: "white",
                "&:hover": {
                  boxShadow: "0px 0px 15px rgba(113, 135, 233, 0.6)",
                },
                padding: "12px",
                fontSize: "16px",
                width: "50%",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
            >
              SIGN IN
            </MDButton>
          </MDBox>
        </Card>
      </MDBox>
    </BasicLayout>
  );
}

export default Basic;
